import { create } from "zustand";

interface ModalStore {
  isOpen: boolean;
  isOpenError?: boolean;
  value?: string;
  setValue?: (value: string) => void;
  openModal: () => void;
  closeModal: () => void;
  openModalError?: () => void;
  closeModalError?: () => void;
}

export const useModalDepositConfirmedStore = create<ModalStore>((set) => ({
  isOpen: false,
  openModal: () => set({ isOpen: true }),
  closeModal: () => set({ isOpen: false }),
}));

export const useModalSuccessfulWithdrawalStore = create<ModalStore>((set) => ({
  isOpen: false,
  isOpenError: false,
  openModal: () => set({ isOpen: true }),
  openModalError: () => set({ isOpenError: true }),
  closeModal: () => set({ isOpen: false }),
  closeModalError: () => set({ isOpenError: false }),
}));

export const useModalSuccessfulMatchingBonusStore = create<ModalStore>(
  (set) => ({
    isOpen: false,
    isOpenError: false,
    openModal: () => set({ isOpen: true }),
    openModalError: () => set({ isOpenError: true }),
    closeModal: () => set({ isOpen: false }),
    closeModalError: () => set({ isOpenError: false }),
  })
);

export const useModalSuccessfulAirdropStore = create<ModalStore>((set) => ({
  isOpen: false,
  isOpenError: false,
  value: "",
  setValue: (value: string) => set({ value }),
  openModal: () => set({ isOpen: true }),
  openModalError: () => set({ isOpenError: true }),
  closeModal: () => set({ isOpen: false }),
  closeModalError: () => set({ isOpenError: false }),
}));

export const useModalSuccessfulReinvestedStore = create<ModalStore>((set) => ({
  isOpen: false,
  openModal: () => set({ isOpen: true }),
  closeModal: () => set({ isOpen: false }),
}));

export const useModalSuccessfulReinvestedMatchingBonusStore =
  create<ModalStore>((set) => ({
    isOpen: false,
    value: "",
    openModal: () => set({ isOpen: true }),
    closeModal: () => set({ isOpen: false }),
    setValue: (value: string) => set({ value }),
  }));

export const useModalSuccessfulReinvestedAirdropStore = create<ModalStore>(
  (set) => ({
    isOpen: false,
    value: "",
    openModal: () => set({ isOpen: true }),
    closeModal: () => set({ isOpen: false }),
    setValue: (value: string) => set({ value }),
  })
);
